import React from 'react';

const Checktick = () => {
  return (
    <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>Group 7</title>
      <desc>Created with Sketch.</desc>
      <g id="LTE" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Cards/Cross-sells/Desktop/Bundles/Plain" transform="translate(-182.000000, -199.000000)">
          <g id="3.-card-tick">
            <g id="Group-2" transform="translate(207.000000, 224.000000) scale(-1, 1) translate(-207.000000, -224.000000) translate(182.000000, 199.000000)">
              <g id="Group-7">
                <path d="M1.20710678,0.5 L49.5,48.7928932 L49.5,4 C49.5,2.06700338 47.9329966,0.5 46,0.5 L1.20710678,0.5 Z" id="Rectangle" stroke="#428600" fill="#428600" transform="translate(25.000000, 25.000000) scale(-1, -1) translate(-25.000000, -25.000000) "></path>
                <polyline id="Path" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" transform="translate(14.230769, 34.000000) scale(-1, 1) translate(-14.230769, -34.000000) " points="20.3846154 30.1538462 11.8638219 37.8461538 8.07692308 34.4274592"></polyline>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Checktick;